// extracted by mini-css-extract-plugin
export default {"ball-pulse-sync":"styles_ball-pulse-sync__jkXHa","section-loader":"styles_section-loader__nXniu"};